module.exports = __webpack_public_path__ + "img/onboard-image-bg.ea052893.png";